import React, { useState, useEffect } from 'react';
import MaintenanceContentES from './MaintenanceContentES';
import MaintenanceContentEN from './MaintenanceContentEN';
import './maintenancePage.css';

const MaintenancePage = ({ isSpanish: propIsSpanish }) => {
    const [currentIsSpanish, setCurrentIsSpanish] = useState(() => {
        // Prioritize lang parameter from URL hash for initial state
        const hash = window.location.hash;
        const queryIndex = hash.indexOf('?');
        if (queryIndex !== -1) {
            const hashQueryString = hash.substring(queryIndex + 1);
            const paramsInHash = new URLSearchParams(hashQueryString);
            if (paramsInHash.has('lang')) {
                return paramsInHash.get('lang') === 'es';
            }
        }
        // Fallback to prop if no lang in URL
        if (typeof propIsSpanish === 'boolean') {
            return propIsSpanish;
        }
        // Default to English (false) if neither is present
        return false;
    });

    // useEffect to update if propIsSpanish changes and no lang in URL was definitive
    // For a page opened in a new tab with lang in URL, this effect might not be critical
    // as the initial state from URL should persist.
    useEffect(() => {
        const hash = window.location.hash;
        const queryIndex = hash.indexOf('?');
        let langInUrl = false;
        if (queryIndex !== -1) {
            const hashQueryString = hash.substring(queryIndex + 1);
            const paramsInHash = new URLSearchParams(hashQueryString);
            if (paramsInHash.has('lang')) {
                langInUrl = true;
            }
        }

        if (!langInUrl && typeof propIsSpanish === 'boolean') {
            setCurrentIsSpanish(propIsSpanish);
        }
    }, [propIsSpanish]);

    // Puedes añadir una clase al body para estilos globales si es necesario
    // React.useEffect(() => {
    //     document.body.classList.add('maintenance-active');
    //     return () => {
    //         document.body.classList.remove('maintenance-active');
    //     };
    // }, []);

    return (
        <>
            {currentIsSpanish ? <MaintenanceContentES /> : <MaintenanceContentEN />}
        </>
    );
};

export default MaintenancePage; 